import { generator, getShadow } from './theme.js';

const shadow = (props) => generator({
    props,
    prop: ['boxShadow', 'elevation'],
    cssProperty: 'boxShadow',
    getter: getShadow,
});

export { shadow };
